import React from 'react'
import useWillClearConstrainOnUnmount from './use-will-clear-constrain-on-unmount'
import useWillOnlyConstrain from './use-will-only-constrain'

export default function useWillConstrain(name, value, shouldConstrainCheck = null) {
    useWillClearConstrainOnUnmount(name);
    useWillOnlyConstrain(name, value, shouldConstrainCheck)
}
